<template>
  <v-app class="back">
    <v-container fluid>
      <v-row justify="center">
        <!-- <v-spacer></v-spacer> -->
        <v-col justify="center" class="text-center">
          <!-- <v-img justify="center" class="foto" src="../assets/Group.png" /> -->
          <img class="foto" src="../assets/Group.png" />
        </v-col>
        <!-- <v-col class="mt-4">
          <v-btn rounded class="white--text" to="/login" color="#283480">Fazer login</v-btn>
        </v-col>-->
        <v-btn
          rounded
          outlined
          color="#283480"
          @click="dialog_buscar_clube = true"
          >Entrar</v-btn
        >
      </v-row>
      <v-row no-gutters justify="center" class="mt-12">
        <v-card
          flat
          height="410"
          class="borda mx-6 plano"
          width="270"
          v-for="(item, index) in api_planos"
          :key="index"
        >
          <v-card-title class="azul_fundo">
            <v-row justify="center">
              <span class="font-weight-bold headline agua text-center">
                R$
                <span
                  v-if="!item.isAnual"
                  v-text="format_valor(item.plano_valor_mensal)"
                ></span>
                <span
                  v-if="item.isAnual"
                  v-text="format_valor(item.plano_valor_anual)"
                ></span
                >/mês
              </span>
            </v-row>
          </v-card-title>
          <v-row justify="center">
            <v-switch inset color="#283480" v-model="item.isAnual">
              <template v-slot:label>Contratação Anual</template>
            </v-switch>
          </v-row>
          <v-card-text class="itens_plano">
            <v-row justify="center" class="mt-0">
              <span
                class="black--text font-weight-bold text-center nome_plano"
                >{{ item.plano_nome }}</span
              >
            </v-row>
            <v-row justify="center">
              <span
                v-if="!item.plano_tempo_avaliacao <= 0"
                class="black--text subtitle-1 text-center"
                >{{ item.plano_tempo_avaliacao }} dias gratuitos!</span
              >
            </v-row>
            <v-row justify="center" class="mt-2">
              <span class="black--text subtitle-1 text-center">
                PROMOCIONAL!
                <br />
                {{ item.plano_descricao }}
              </span>
            </v-row>
            <div class="mt-6"></div>
            <v-row justify="center" hidden>
              <span class="subtitle-1 black--text text-center"
                >Até {{ item.plano_limite_associados }} Associados</span
              >
            </v-row>
            <v-row justify="center" class="mt-n2">
              <span class="subtitle-1 black--text text-center"
                >{{ item.plano_megabytes }}MB de armazenamento</span
              >
            </v-row>
            <v-row
              class="mt-1"
              justify="center"
              v-for="(modulo, i) in item.modulos"
              :key="i"
              hidden
            >
              <span class="black--text subtitle-1 text-center">{{
                modulo.modulo_nome
              }}</span>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-btn
                rounded
                class="white--text"
                color="#283480"
                v-if="!item.isAnual"
                :to="'/novo_plano/' + item.id_plano + '/mensal'"
                >Contratar</v-btn
              >
              <v-btn
                rounded
                class="white--text"
                color="#283480"
                v-if="item.isAnual"
                :to="'/novo_plano/' + item.id_plano + '/anual'"
                >Contratar</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-row>

      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="getPlanosPersonalizados()"
      >
        <v-row no-gutters justify="center">
          <v-col md="3">
            <span class="font-weight-bold black--text"
              >Código do Plano Personalizado</span
            >
            <v-text-field
              v-model="plano_codigo"
              solo
              dense
              flat
              outlined
              required
              :rules="requiredRules"
            ></v-text-field>
          </v-col>
          <v-btn
            rounded
            color="#283480"
            class="mt-6 ml-3 white--text"
            :loading="loadingCustom"
            :disabled="loadingCustom"
            type="submit"
            >Buscar</v-btn
          >
        </v-row>
      </v-form>

      <v-row justify="center">
        <v-label v-if="buscaPlano && planos_personalizados.length == 0"
          >Nenhum plano encontrado</v-label
        >
        <v-card
          flat
          height="410"
          class="borda mx-6 plano"
          width="270"
          v-for="(item, index) in planos_personalizados"
          :key="index"
        >
          <v-card-title class="azul_fundo">
            <v-row justify="center">
              <span class="font-weight-bold headline agua text-center">
                R$
                <span
                  v-if="!item.isAnual"
                  v-text="format_valor(item.plano_valor_mensal)"
                ></span>
                <span
                  v-if="item.isAnual"
                  v-text="format_valor(item.plano_valor_anual)"
                ></span
                >/mês
              </span>
            </v-row>
          </v-card-title>
          <v-row justify="center">
            <v-switch inset color="#283480" v-model="item.isAnual">
              <template v-slot:label>Contratação Anual</template>
            </v-switch>
          </v-row>
          <v-card-text class="itens_plano">
            <v-row justify="center" class="mt-0">
              <span
                class="black--text font-weight-bold text-center nome_plano"
                >{{ item.plano_nome }}</span
              >
            </v-row>
            <v-row justify="center">
              <span
                v-if="!item.plano_tempo_avaliacao <= 0"
                class="black--text subtitle-1 text-center"
                >{{ item.plano_tempo_avaliacao }} dias gratuitos!</span
              >
            </v-row>
            <v-row justify="center" class="mt-2">
              <span class="black--text subtitle-1 text-center">
                PROMOCIONAL!
                <br />
                {{ item.plano_descricao }}
              </span>
            </v-row>
            <div class="mt-6"></div>
            <v-row justify="center" hidden>
              <span class="subtitle-1 black--text text-center"
                >Até {{ item.plano_limite_associados }} Associados</span
              >
            </v-row>
            <v-row justify="center" class="mt-n2">
              <span class="subtitle-1 black--text text-center"
                >{{ item.plano_megabytes }}MB de armazenamento</span
              >
            </v-row>
            <v-row
              class="mt-1"
              justify="center"
              v-for="(modulo, i) in item.modulos"
              :key="i"
              hidden
            >
              <span class="black--text subtitle-1 text-center">{{
                modulo.modulo_nome
              }}</span>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-btn
                rounded
                class="white--text"
                color="#283480"
                v-if="!item.isAnual"
                :to="'/novo_plano/' + item.id_plano + '/mensal'"
                >Contratar</v-btn
              >
              <v-btn
                rounded
                class="white--text"
                color="#283480"
                v-if="item.isAnual"
                :to="'/novo_plano/' + item.id_plano + '/anual'"
                >Contratar</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog_buscar_clube" persistent max-width="550">
      <v-form ref="form2" v-model="valid" @submit.prevent="buscarClube()">
        <v-card class="borda" flat>
          <v-card-title> Buscar clube </v-card-title>
          <v-card-text class="black--text">
            <v-text-field
              label="Nome do clube"
              :rules="requiredRules"
              solo
              dense
              v-model="clube_string"
              flat
              outlined
              hide-details="auto"
            ></v-text-field>

            <v-simple-table v-if="clubeAchado.clube_slug" class="my-2">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Nome do clube</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ clubeAchado.clube_nome_comercial }}</td>
                    <td>
                      <a
                        class="black--text"
                        :href="apiLink + clubeAchado.clube_slug"
                      >
                        <v-btn small outlined rounded color="#283480">Acessar clube</v-btn>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>

            <v-card-actions>
              <v-row justify="center">
                <v-btn
                  rounded
                  color="#283480"
                  @click="
                    (clube_string = ''),
                      (dialog_buscar_clube = false),
                      $refs.form2.resetValidation()
                  "
                  :disabled="loadingBuscar"
                  outlined
                  >Cancelar</v-btn
                >
                <v-btn
                  rounded
                  color="#283480"
                  class="ml-2 white--text"
                  :disabled="loadingBuscar"
                  :loading="loadingBuscar"
                  @click="buscarClube(clube_string)"
                  >Buscar</v-btn
                >
              </v-row>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
export default {
  data() {
    return {
      loadingBuscar: false,
      apiLink: Api.getAplicationUrl(),
      clubeAchado: [],
      dialog_buscar_clube: false,
      clube_string: "",
      api_planos: [],
      api_modulos: [],
      taxados: [],
      plano_codigo: "",
      loadingCustom: false,
      planos_personalizados: [],
      valid: true,
      requiredRules: [(v) => !!v || "Campo Obrigatório."],
      buscaPlano: false,
    };
  },
  created() {
    this.getPlanos();
    this.getModulos();
  },

  methods: {
    buscarClube(clube) {
      if (this.$refs.form2.validate()) {
        this.loadingBuscar = true;
        Api.get(`/buscarClube?clube=` + clube)
          .then((response) => {
            this.loadingBuscar = false;
            if (response.data) {
              this.clubeAchado = response.data;
            }
          })
          .catch((err) => {
            this.loadingBuscar = false;
            throw err;
          });
      }
    },
    getPlanos() {
      this.loading = true;
      Api.get(`/planos`)
        .then((response) => {
          if (response.data.data) {
            for (var i = 0; i < response.data.data.length; i++) {
              response.data.data[i].isAnual = true;
            }
            this.api_planos = response.data.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          throw err;
        });
    },
    getPlanosPersonalizados() {
      if (this.$refs.form.validate()) {
        this.loadingCustom = true;
        Api.get(`/planos/personalizados?codigo=` + this.plano_codigo)
          .then((response) => {
            if (response.data.data) {
              for (var i = 0; i < response.data.data.length; i++) {
                response.data.data[i].isAnual = true;
              }
              this.planos_personalizados = response.data.data;
              this.loadingCustom = false;
              this.$vuetify.goTo(9999);
            } else {
              this.planos_personalizados = [];
            }
            this.buscaPlano = true;
          })
          .catch((err) => {
            this.loadingCustom = false;
            this.planos_personalizados = [];
            this.buscaPlano = true;
            throw err;
          });
      }
    },
    format_valor(valor) {
      if (valor) {
        return valor
          .replace(".", ",")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
      }
    },
    changeAnual(index) {
      if (index) {
        // this.api_planos[index].isAnual = true;
      }
    },
    getModulos() {
      this.loading = true;
      Api.get(`/modulos`)
        .then((response) => {
          if (response.data.data) {
            this.api_modulos = response.data.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          throw err;
        });
    },
  },
};
</script>

<style>
.itens_plano {
  min-height: 180px;
}
.azul_fundo {
  background-color: #283480;
}
.plano {
  margin-bottom: 50px;
}
.taxado {
  text-decoration: line-through !important;
}
.foto {
  max-width: 20% !important;
}
.nome_plano {
  font-size: 30px;
  margin-bottom: 5px;
}
@media (max-width: 800px) {
  .foto {
    max-width: 80% !important;
  }
}
</style>